import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'simpati',
    pathMatch: 'full'
  },
  {
    path: 'simpati',
    loadComponent: () => import('./presentation/simpati/simpati.component').then((m) => m.SimpatiComponent),
    data: {
      pageName: 'Simpati'
    }
  },
  {
    path: 'dls',
    data: {
      pageName: 'dls'
    },
    children: [
      {
        path: '',
        redirectTo: 'music',
        pathMatch: 'full'
      },
      {
        path: ':category',
        loadComponent: () =>
          import('./presentation/dls/dls.component').then((c) => c.DlsComponent)
      }
    ]
  },
  {
    path: 'halo',
    loadComponent: () =>
      import('./presentation/halo/halo.component').then((c) => c.HaloComponent),
    data: {
      pageName: 'halo'
    }
  }
];
